import React from 'react';
import { get, invoke } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { InputLabel } from '@mui/material';
import MenuItem from '../MenuItem/MenuItem';
import Select from '../Select/Select';
import { isDesktop } from '../../services/isMobile';

export const TimeFormatType = {
  UTC: 'UTC',
  USER: 'USER',
  PLAZA: 'PLAZA',
};

export const getOffsetByFormatType = (format, plaza) => {
  switch (format) {
    case TimeFormatType.UTC:
      return 0;
    case TimeFormatType.USER:
      return moment().utcOffset() / 60;
    case TimeFormatType.PLAZA:
      return moment().tz(plaza.timeZone).utcOffset() / 60;
    default: {
      console.error('Unprocessed format ', format);

      return 0;
    }
  }
};

const MIN_TIMESELECT_WIDTH = '135px';

export function TimeFormat(props) {
  const { value, onChange, plaza = null, className = null, selectProps = {} } = props;

  function item(text, value) {
    return (
      <div className="time-format-item">
        <div>{text}</div>&nbsp;
        <div>{value}</div>
      </div>
    );
  }

  const options = [
    {
      value: TimeFormatType.UTC,
      label: item(TimeFormatType.UTC, moment().utc().format('Z')),
      title: 'Coordinated Universal Time',
    },
    {
      value: TimeFormatType.USER,
      label: item(TimeFormatType.USER, moment().format('Z')),
      title: get(invoke(invoke(Intl, 'DateTimeFormat'), 'resolvedOptions'), 'timeZone'),
    },
  ];

  if (plaza.timeZone) {
    options.push({
      value: TimeFormatType.PLAZA,
      label: item(TimeFormatType.PLAZA, moment().tz(plaza.timeZone).format('Z')),
      title: plaza.address,
    });
  }

  const children = options.map((option) => (
    <MenuItem key={option.value} title={option.title} value={option.value}>
      {option.label}
    </MenuItem>
  ));

  return (
    <>
      <div className={`time-format ${className}`}>
        {isDesktop && <InputLabel shrink>Time Zone:</InputLabel>}
        <Select
          value={value}
          onChange={(e) => {
            const format = e.target.value;

            if (onChange && format) {
              onChange({ format, offset: getOffsetByFormatType(format, plaza) });
            }
          }}
          fullWidth
          style={{
            minWidth: MIN_TIMESELECT_WIDTH,
          }}
          MenuProps={{
            slotProps: {
              paper: {
                style: {
                  minWidth: MIN_TIMESELECT_WIDTH,
                },
              },
            },
          }}
          {...selectProps}
        >
          {children}
        </Select>
      </div>
    </>
  );
}

TimeFormat.propTypes = {
  value: PropTypes.oneOf([TimeFormatType.UTC, TimeFormatType.USER, TimeFormatType.PLAZA]),
  onChange: PropTypes.func,
  plaza: PropTypes.object,
};
